import { getImpersonationDetails, stopImpersonation } from "@/services/auth";
import { Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";

export const ImpersonatedUserBanner = () => {
  const impersonatedUser = getImpersonationDetails();

  if (!impersonatedUser) {
    return null;
  }

  return (
    <div
      className={
        "al-bg-orange-500 al-text-white -al-mx-1 -al-mt-1 al-mb-1 al-p-2 al-pb-4 space-y-2 al-text-center"
      }
    >
      <span>
        Currently impersonating user <strong>{impersonatedUser?.email}</strong>
      </span>
      <Stack align="center" justify="center">
        <Button
          size={"xs"}
          variant={"outline"}
          onClick={() => stopImpersonation()}
          className={
            "al-mt-4 al-w-2/3 al-bg-transparent al-border-white hover:al-bg-orange-700 hover:al-text-white"
          }
        >
          Stop Impersonating
        </Button>
      </Stack>
    </div>
  );
};
